import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Loader.css';

const Loader = ({
  text        = null,
  texts       = null,
  interval    = 2500,
  showDots    = true,
  // ── progress bar ──────────────────────────────────────────────
  progress    = null,   // 0-100, shows bar if provided
  // ── logo variant ──────────────────────────────────────────────
  logo= "/images/cp-logo.svg",
  logoAlt     = null,
    inline = false,   

  // ── visibility ────────────────────────────────────────────────
  visible     = true,   // controls fade out
}) => {

  const [currentIndex, setCurrentIndex] = useState(0);
  const [textVisible,  setTextVisible]  = useState(true);
  const { t } = useTranslation('translation');
const LOGO_ALIASES = {
  flow: '/images/spaceman-transparent-icon.png',
};

const resolvedLogo = LOGO_ALIASES[logo] ?? logo;
  const resolvedText = text ?? t('ui.loader.loading', 'Loading');
  const resolvedLogoAlt = logoAlt ?? t('ui.loader.logo_alt', 'Logo');
  useEffect(() => {
    if (!texts?.length) return;
    const timer = setInterval(() => {
      setTextVisible(false);
      setTimeout(() => {
        setCurrentIndex((i) => (i + 1) % texts.length);
        setTextVisible(true);
      }, 300);
    }, interval);
    return () => clearInterval(timer);
  }, [texts, interval]);

  const displayText = texts?.length ? texts[currentIndex] : resolvedText;

  return (
<div className={inline
  ? 'loader-inline'
  : `fullscreen-loading-overlay ${!visible ? 'fullscreen-loading-overlay--hidden' : ''}`
}>      {/* spinner ring — with logo if provided, plain spinner if not */}
      <div className="loading-logo-container">
    
    <img src={resolvedLogo} alt={resolvedLogoAlt} className="loading-logo" />
       
        <div className="loading-spinner-ring" style={{zIndex:'999'}}/>
      </div>

      {/* text */}
      {displayText && (
        <p className={`loader-text ${textVisible ? 'loader-text--visible' : 'loader-text--hidden'}`}>
          {displayText}
          {showDots && (
            <span className="loader-dots">
              <span>.</span><span>.</span><span>.</span>
            </span>
          )}
        </p>
      )}

      {/* progress bar — only shown when progress prop is provided */}
      {progress !== null && (
        <div className="loading-progress">
          <div
            className="loading-progress-bar"
            style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
          />
        </div>
      )}

    </div>
  );
};

export default Loader;